var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDependentGradient = function SvgDependentGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 7.4c.845 0 1.656-.337 2.254-.937a3.207 3.207 0 0 0 0-4.526 3.182 3.182 0 0 0-4.508 0 3.207 3.207 0 0 0 0 4.526c.598.6 1.409.937 2.254.937Zm0-5.333c.564 0 1.104.224 1.502.624a2.138 2.138 0 0 1 0 3.017 2.12 2.12 0 0 1-3.005 0 2.137 2.137 0 0 1 .001-3.016c.398-.4.938-.625 1.502-.625ZM13.75 10.6a2.12 2.12 0 0 0 1.502-.625 2.138 2.138 0 0 0 0-3.017 2.121 2.121 0 0 0-3.005 0 2.138 2.138 0 0 0 0 3.017c.399.4.94.625 1.503.625Zm0-3.2c.282 0 .552.112.751.312a1.07 1.07 0 0 1-.751 1.821 1.068 1.068 0 0 1 0-2.133Zm2.125 4.267h-4.25c-.564 0-1.104.224-1.503.624-.398.4-.622.943-.622 1.509v1.067c.002.375.104.743.295 1.066h-6.67a1.07 1.07 0 0 1-1.062-1.067v-3.2c0-.565.224-1.107.623-1.507.398-.4.938-.625 1.501-.626h6.375V8.467H4.187c-.845 0-1.656.337-2.253.937A3.206 3.206 0 0 0 1 11.667v3.2c0 .565.224 1.108.622 1.508.399.4.94.625 1.503.625h12.75c.564 0 1.104-.225 1.503-.625.398-.4.622-.943.622-1.508V13.8c0-.566-.224-1.108-.622-1.509-.399-.4-.94-.624-1.503-.624Zm1.062 3.2a1.07 1.07 0 0 1-1.062 1.066h-4.25a1.07 1.07 0 0 1-1.063-1.067V13.8a1.07 1.07 0 0 1 1.063-1.067h4.25a1.062 1.062 0 0 1 1.062 1.067v1.067Z",
    fill: "url(#DependentGradient_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "DependentGradient_svg__a",
    x1: 1,
    y1: 9,
    x2: 18,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })))));
};

export default SvgDependentGradient;